// Per-resource load state (spec §12). Objects are mutated in place so Vue reactivity sees changes.

export function createResource() {
  return { status: 'idle', data: [], error: null };
}

/** A resource holding one value (an object or null) instead of a list. */
export function createValueResource() {
  return { status: 'idle', data: null, error: null };
}

export function setLoading(r) {
  r.status = 'loading';
  r.error = null;
}

export function setReady(r, data, { value = false } = {}) {
  r.status = 'ready';
  if (value) r.data = data === undefined ? null : data;
  else r.data = Array.isArray(data) ? data : [];
  r.error = null;
}

export function setError(r, error) {
  r.status = 'error';
  r.error = error instanceof Error || (error && typeof error === 'object') ? error : new Error(String(error || 'unknown'));
}

export function isReady(r) {
  return !!r && r.status === 'ready';
}

/** Runs fetcher, settles the resource, never rejects. Resolves true on success. */
export async function loadResource(r, fetcher, { value = false } = {}) {
  setLoading(r);
  try {
    const data = await fetcher();
    setReady(r, data, { value });
    return true;
  } catch (e) {
    setError(r, e);
    return false;
  }
}

export function errorMessage(error, fallback = 'Ошибка запроса') {
  if (typeof error === 'string' && error) return error;
  const m = error && error.response && error.response.data && error.response.data.message;
  return typeof m === 'string' && m ? m : fallback;
}
